import http from '../helpers/http';
import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';
import FranchiseeInterface from '../interfaces/FranchiseeInterface';

const Franchisee = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async (filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get('/franchisees', {
        headers,
        params,
      });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/franchisees/${id}`, {
        headers,
      });
      return result.data;
    },
    create: async (body: Partial<FranchiseeInterface>) => {
      const result = await http.post(`/franchisees`, body, { headers });
      return result.data;
    },
    update: async (id: string, body: Partial<FranchiseeInterface>) => {
      const result = await http.put(`/franchisees/${id}`, body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/franchisees/${id}`, {
        headers,
      });
      return result.data;
    },
    listSelect: async () => {
      const result = await http.get(`/franchisees/select/all`, {
        headers,
      });
      return result.data;
    },
    picture: async (franchiseeId: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/franchisees/${franchiseeId}/picture`, body, headers);
      return result.data;
    },
    getIntegration: async (id: string) => {
      const result = await http.get(`/franchisees/${id}/integration`, { headers });
      return result.data;
    },
    getIntegrationOrganizations: async (id: string) => {
      const result = await http.get(`/franchisees/${id}/integration/organizations`, { headers });
      return result.data;
    },
    createOrUpdateIntegration: async (
      id: string,
      body: {
        type: string;
        apiKey?: string;
        apiToken?: string;
        apiSecret?: string;
        configSchools?: Array<{
          departmentId: string;
          categoryId: string;
          categoryLabel?: string;
          organizationId: string;
          boardId: string;
          listId: string;
          organizationLabel?: string;
          boardLabel?: string;
          listLabel?: string;
          boardConfigType?: 'school-as-label' | 'school-as-list';
        }>;
        attachmentMaxSizeMb?: number;
      } | null,
    ) => {
      const result = await http.put(`/franchisees/${id}/integration`, body, { headers });
      return result.data;
    },
    verifyIntegration: async (
      id: string,
      body: { type: string; apiKey: string; apiToken: string; apiSecret?: string },
    ) => {
      const result = await http.post(`/franchisees/${id}/integration/verify`, body, { headers });
      return result.data;
    },
  };
};

export default Franchisee;
